export const countries = [
  {
    name: 'Afghanistan',
    short_name: 'Afghanistan',
    flag: '🇦🇫',
    alpha2: 'AF',
    alpha3: 'AFG',
    numeric: '004',
  },
  {
    name: 'Åland Islands',
    short_name: 'Åland Islands',
    flag: '🇦🇽',
    alpha2: 'AX',
    alpha3: 'ALA',
    numeric: '248',
  },
  {
    name: 'Albania',
    short_name: 'Albania',
    flag: '🇦🇱',
    alpha2: 'AL',
    alpha3: 'ALB',
    numeric: '008',
  },
  {
    name: 'Algeria',
    short_name: 'Algeria',
    flag: '🇩🇿',
    alpha2: 'DZ',
    alpha3: 'DZA',
    numeric: '012',
  },
  {
    name: 'American Samoa',
    short_name: 'American Samoa',
    flag: '🇺🇸',
    alpha2: 'AS',
    alpha3: 'ASM',
    numeric: '016',
  },
  {
    name: 'Andorra',
    short_name: 'Andorra',
    flag: '🇦🇩',
    alpha2: 'AD',
    alpha3: 'AND',
    numeric: '020',
  },
  {
    name: 'Angola',
    short_name: 'Angola',
    flag: '🇦🇴',
    alpha2: 'AO',
    alpha3: 'AGO',
    numeric: '024',
  },
  {
    name: 'Anguilla',
    short_name: 'Anguilla',
    flag: '🇦🇮',
    alpha2: 'AI',
    alpha3: 'AIA',
    numeric: '660',
  },
  {
    name: 'Antarctica',
    short_name: 'Antarctica',
    flag: '🇦🇶',
    alpha2: 'AQ',
    alpha3: 'ATA',
    numeric: '010',
  },
  {
    name: 'Antigua and Barbuda',
    short_name: 'Antigua and Barbuda',
    flag: '🇦🇬',
    alpha2: 'AG',
    alpha3: 'ATG',
    numeric: '028',
  },
  {
    name: 'Argentina',
    short_name: 'Argentina',
    flag: '🇦🇷',
    alpha2: 'AR',
    alpha3: 'ARG',
    numeric: '032',
  },
  {
    name: 'Armenia',
    short_name: 'Armenia',
    flag: '🇦🇲',
    alpha2: 'AM',
    alpha3: 'ARM',
    numeric: '051',
  },
  {
    name: 'Aruba',
    short_name: 'Aruba',
    flag: '🇦🇼',
    alpha2: 'AW',
    alpha3: 'ABW',
    numeric: '533',
  },
  {
    name: 'Australia',
    short_name: 'Australia',
    flag: '🇦🇺',
    alpha2: 'AU',
    alpha3: 'AUS',
    numeric: '036',
  },
  {
    name: 'Austria',
    short_name: 'Austria',
    flag: '🇦🇹',
    alpha2: 'AT',
    alpha3: 'AUT',
    numeric: '040',
  },
  {
    name: 'Azerbaijan',
    short_name: 'Azerbaijan',
    flag: '🇦🇿',
    alpha2: 'AZ',
    alpha3: 'AZE',
    numeric: '031',
  },
  {
    name: 'Bahamas',
    short_name: 'Bahamas',
    flag: '🇧🇸',
    alpha2: 'BS',
    alpha3: 'BHS',
    numeric: '044',
  },
  {
    name: 'Bahrain',
    short_name: 'Bahrain',
    flag: '🇧🇭',
    alpha2: 'BH',
    alpha3: 'BHR',
    numeric: '048',
  },
  {
    name: 'Bangladesh',
    short_name: 'Bangladesh',
    flag: '🇧🇩',
    alpha2: 'BD',
    alpha3: 'BGD',
    numeric: '050',
  },
  {
    name: 'Barbados',
    short_name: 'Barbados',
    flag: '🇧🇧',
    alpha2: 'BB',
    alpha3: 'BRB',
    numeric: '052',
  },
  {
    name: 'Belarus',
    short_name: 'Belarus',
    flag: '🇧🇾',
    alpha2: 'BY',
    alpha3: 'BLR',
    numeric: '112',
  },
  {
    name: 'Belgium',
    short_name: 'Belgium',
    flag: '🇧🇪',
    alpha2: 'BE',
    alpha3: 'BEL',
    numeric: '056',
  },
  {
    name: 'Belize',
    short_name: 'Belize',
    flag: '🇧🇿',
    alpha2: 'BZ',
    alpha3: 'BLZ',
    numeric: '084',
  },
  {
    name: 'Benin',
    short_name: 'Benin',
    flag: '🇧🇯',
    alpha2: 'BJ',
    alpha3: 'BEN',
    numeric: '204',
  },
  {
    name: 'Bermuda',
    short_name: 'Bermuda',
    flag: '🇧🇲',
    alpha2: 'BM',
    alpha3: 'BMU',
    numeric: '060',
  },
  {
    name: 'Bhutan',
    short_name: 'Bhutan',
    flag: '🇧🇹',
    alpha2: 'BT',
    alpha3: 'BTN',
    numeric: '064',
  },
  {
    name: 'Bolivia, Plurinational State of Bolivia',
    short_name: 'Bolivia',
    flag: '🇧🇴',
    alpha2: 'BO',
    alpha3: 'BOL',
    numeric: '068',
  },
  {
    name: 'Bosnia and Herzegovina',
    short_name: 'Bosnia and Herzegovina',
    flag: '🇧🇦',
    alpha2: 'BA',
    alpha3: 'BIH',
    numeric: '070',
  },
  {
    name: 'Botswana',
    short_name: 'Botswana',
    flag: '🇧🇼',
    alpha2: 'BW',
    alpha3: 'BWA',
    numeric: '072',
  },
  {
    name: 'Bouvet Island',
    short_name: 'Bouvet Island',
    flag: '🏳',
    alpha2: 'BV',
    alpha3: 'BVT',
    numeric: '074',
  },
  {
    name: 'Brazil',
    short_name: 'Brazil',
    flag: '🇧🇷',
    alpha2: 'BR',
    alpha3: 'BRA',
    numeric: '076',
  },
  {
    name: 'British Indian Ocean Territory',
    short_name: 'British Indian Ocean Territory',
    flag: '🇮🇴',
    alpha2: 'IO',
    alpha3: 'IOT',
    numeric: '086',
  },
  {
    name: 'Brunei Darussalam',
    short_name: 'Brunei',
    flag: '🇧🇳',
    alpha2: 'BN',
    alpha3: 'BRN',
    numeric: '096',
  },
  {
    name: 'Bulgaria',
    short_name: 'Bulgaria',
    flag: '🇧🇬',
    alpha2: 'BG',
    alpha3: 'BGR',
    numeric: '100',
  },
  {
    name: 'Burkina Faso',
    short_name: 'Burkina Faso',
    flag: '🇧🇫',
    alpha2: 'BF',
    alpha3: 'BFA',
    numeric: '854',
  },
  {
    name: 'Burundi',
    short_name: 'Burundi',
    flag: '🇧🇮',
    alpha2: 'BI',
    alpha3: 'BDI',
    numeric: '108',
  },
  {
    name: 'Cambodia',
    short_name: 'Cambodia',
    flag: '🇰🇭',
    alpha2: 'KH',
    alpha3: 'KHM',
    numeric: '116',
  },
  {
    name: 'Cameroon',
    short_name: 'Cameroon',
    flag: '🇨🇲',
    alpha2: 'CM',
    alpha3: 'CMR',
    numeric: '120',
  },
  {
    name: 'Canada',
    short_name: 'Canada',
    flag: '🇨🇦',
    alpha2: 'CA',
    alpha3: 'CAN',
    numeric: '124',
  },
  {
    name: 'Cape Verde',
    short_name: 'Cape Verde',
    flag: '🇨🇻',
    alpha2: 'CV',
    alpha3: 'CPV',
    numeric: '132',
  },
  {
    name: 'Cayman Islands',
    short_name: 'Cayman Islands',
    flag: '🇰🇾',
    alpha2: 'KY',
    alpha3: 'CYM',
    numeric: '136',
  },
  {
    name: 'Central African Republic',
    short_name: 'Central African Republic',
    flag: '🇨🇫',
    alpha2: 'CF',
    alpha3: 'CAF',
    numeric: '140',
  },
  {
    name: 'Chad',
    short_name: 'Chad',
    flag: '🇹🇩',
    alpha2: 'TD',
    alpha3: 'TCD',
    numeric: '148',
  },
  {
    name: 'Chile',
    short_name: 'Chile',
    flag: '🇨🇱',
    alpha2: 'CL',
    alpha3: 'CHL',
    numeric: '152',
  },
  {
    name: 'China',
    short_name: 'China',
    flag: '🇨🇳',
    alpha2: 'CN',
    alpha3: 'CHN',
    numeric: '156',
  },
  {
    name: 'Christmas Island',
    short_name: 'Christmas Island',
    flag: '🇨🇽',
    alpha2: 'CX',
    alpha3: 'CXR',
    numeric: '162',
  },
  {
    name: 'Cocos (Keeling) Islands',
    short_name: 'Cocos Islands',
    flag: '🇨🇨',
    alpha2: 'CC',
    alpha3: 'CCK',
    numeric: '166',
  },
  {
    name: 'Colombia',
    short_name: 'Colombia',
    flag: '🇨🇴',
    alpha2: 'CO',
    alpha3: 'COL',
    numeric: '170',
  },
  {
    name: 'Comoros',
    short_name: 'Comoros',
    flag: '🇰🇲',
    alpha2: 'KM',
    alpha3: 'COM',
    numeric: '174',
  },
  {
    name: 'Congo',
    short_name: 'Congo',
    flag: '🇨🇬',
    alpha2: 'CG',
    alpha3: 'COG',
    numeric: '178',
  },
  {
    name: 'Congo, The Democratic Republic of the Congo',
    short_name: 'DR Congo',
    flag: '🇨🇩',
    alpha2: 'CD',
    alpha3: 'COD',
    numeric: '180',
  },
  {
    name: 'Cook Islands',
    short_name: 'Cook Islands',
    flag: '🇨🇰',
    alpha2: 'CK',
    alpha3: 'COK',
    numeric: '184',
  },
  {
    name: 'Costa Rica',
    short_name: 'Costa Rica',
    flag: '🇨🇷',
    alpha2: 'CR',
    alpha3: 'CRI',
    numeric: '188',
  },
  {
    name: "Cote d'Ivoire",
    short_name: "Cote d'Ivoire",
    flag: '🇨🇮',
    alpha2: 'CI',
    alpha3: 'CIV',
    numeric: '384',
  },
  {
    name: 'Croatia',
    short_name: 'Croatia',
    flag: '🇭🇷',
    alpha2: 'HR',
    alpha3: 'HRV',
    numeric: '191',
  },
  {
    name: 'Cuba',
    short_name: 'Cuba',
    flag: '🇨🇺',
    alpha2: 'CU',
    alpha3: 'CUB',
    numeric: '192',
  },
  {
    name: 'Cyprus',
    short_name: 'Cyprus',
    flag: '🇨🇾',
    alpha2: 'CY',
    alpha3: 'CYP',
    numeric: '196',
  },
  {
    name: 'Czech Republic',
    short_name: 'Czech Republic',
    flag: '🇨🇿',
    alpha2: 'CZ',
    alpha3: 'CZE',
    numeric: '203',
  },
  {
    name: 'Denmark',
    short_name: 'Denmark',
    flag: '🇩🇰',
    alpha2: 'DK',
    alpha3: 'DNK',
    numeric: '208',
  },
  {
    name: 'Djibouti',
    short_name: 'Djibouti',
    flag: '🇩🇯',
    alpha2: 'DJ',
    alpha3: 'DJI',
    numeric: '262',
  },
  {
    name: 'Dominica',
    short_name: 'Dominica',
    flag: '🇩🇲',
    alpha2: 'DM',
    alpha3: 'DMA',
    numeric: '212',
  },
  {
    name: 'Dominican Republic',
    short_name: 'Dominican Republic',
    flag: '🇩🇴',
    alpha2: 'DO',
    alpha3: 'DOM',
    numeric: '214',
  },
  {
    name: 'Ecuador',
    short_name: 'Ecuador',
    flag: '🇪🇨',
    alpha2: 'EC',
    alpha3: 'ECU',
    numeric: '218',
  },
  {
    name: 'Egypt',
    short_name: 'Egypt',
    flag: '🇪🇬',
    alpha2: 'EG',
    alpha3: 'EGY',
    numeric: '818',
  },
  {
    name: 'El Salvador',
    short_name: 'El Salvador',
    flag: '🇸🇻',
    alpha2: 'SV',
    alpha3: 'SLV',
    numeric: '222',
  },
  {
    name: 'Equatorial Guinea',
    short_name: 'Equatorial Guinea',
    flag: '🇬🇶',
    alpha2: 'GQ',
    alpha3: 'GNQ',
    numeric: '226',
  },
  {
    name: 'Eritrea',
    short_name: 'Eritrea',
    flag: '🇪🇷',
    alpha2: 'ER',
    alpha3: 'ERI',
    numeric: '232',
  },
  {
    name: 'Estonia',
    short_name: 'Estonia',
    flag: '🇪🇪',
    alpha2: 'EE',
    alpha3: 'EST',
    numeric: '233',
  },
  {
    name: 'Ethiopia',
    short_name: 'Ethiopia',
    flag: '🇪🇹',
    alpha2: 'ET',
    alpha3: 'ETH',
    numeric: '231',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    short_name: 'Falkland Islands',
    flag: '🇫🇰',
    alpha2: 'FK',
    alpha3: 'FLK',
    numeric: '238',
  },
  {
    name: 'Faroe Islands',
    short_name: 'Faroe Islands',
    flag: '🇫🇴',
    alpha2: 'FO',
    alpha3: 'FRO',
    numeric: '234',
  },
  {
    name: 'Fiji',
    short_name: 'Fiji',
    flag: '🇫🇯',
    alpha2: 'FJ',
    alpha3: 'FJI',
    numeric: '242',
  },
  {
    name: 'Finland',
    short_name: 'Finland',
    flag: '🇫🇮',
    alpha2: 'FI',
    alpha3: 'FIN',
    numeric: '246',
  },
  {
    name: 'France',
    short_name: 'France',
    flag: '🇫🇷',
    alpha2: 'FR',
    alpha3: 'FRA',
    numeric: '250',
  },
  {
    name: 'French Guiana',
    short_name: 'French Guiana',
    flag: '🇬🇫',
    alpha2: 'GF',
    alpha3: 'GUF',
    numeric: '254',
  },
  {
    name: 'French Polynesia',
    short_name: 'French Polynesia',
    flag: '🇵🇫',
    alpha2: 'PF',
    alpha3: 'PYF',
    numeric: '258',
  },
  {
    name: 'French Southern Territories',
    short_name: 'French Southern Territories',
    flag: '🇹🇫',
    alpha2: 'TF',
    alpha3: 'ATF',
    numeric: '260',
  },
  {
    name: 'Gabon',
    short_name: 'Gabon',
    flag: '🇬🇦',
    alpha2: 'GA',
    alpha3: 'GAB',
    numeric: '266',
  },
  {
    name: 'Gambia',
    short_name: 'Gambia',
    flag: '🇬🇲',
    alpha2: 'GM',
    alpha3: 'GMB',
    numeric: '270',
  },
  {
    name: 'Georgia',
    short_name: 'Georgia',
    flag: '🇬🇪',
    alpha2: 'GE',
    alpha3: 'GEO',
    numeric: '268',
  },
  {
    name: 'Germany',
    short_name: 'Germany',
    flag: '🇩🇪',
    alpha2: 'DE',
    alpha3: 'DEU',
    numeric: '276',
  },
  {
    name: 'Ghana',
    short_name: 'Ghana',
    flag: '🇬🇭',
    alpha2: 'GH',
    alpha3: 'GHA',
    numeric: '288',
  },
  {
    name: 'Gibraltar',
    short_name: 'Gibraltar',
    flag: '🇬🇮',
    alpha2: 'GI',
    alpha3: 'GIB',
    numeric: '292',
  },
  {
    name: 'Greece',
    short_name: 'Greece',
    flag: '🇬🇷',
    alpha2: 'GR',
    alpha3: 'GRC',
    numeric: '300',
  },
  {
    name: 'Greenland',
    short_name: 'Greenland',
    flag: '🇬🇱',
    alpha2: 'GL',
    alpha3: 'GRL',
    numeric: '304',
  },
  {
    name: 'Grenada',
    short_name: 'Grenada',
    flag: '🇬🇩',
    alpha2: 'GD',
    alpha3: 'GRD',
    numeric: '308',
  },
  {
    name: 'Guadeloupe',
    short_name: 'Guadeloupe',
    flag: '🇬🇵',
    alpha2: 'GP',
    alpha3: 'GLP',
    numeric: '312',
  },
  {
    name: 'Guam',
    short_name: 'Guam',
    flag: '🇬🇺',
    alpha2: 'GU',
    alpha3: 'GUM',
    numeric: '316',
  },
  {
    name: 'Guatemala',
    short_name: 'Guatemala',
    flag: '🇬🇹',
    alpha2: 'GT',
    alpha3: 'GTM',
    numeric: '320',
  },
  {
    name: 'Guernsey',
    short_name: 'Guernsey',
    flag: '🇬🇬',
    alpha2: 'GG',
    alpha3: 'GGY',
    numeric: '831',
  },
  {
    name: 'Guinea',
    short_name: 'Guinea',
    flag: '🇬🇳',
    alpha2: 'GN',
    alpha3: 'GIN',
    numeric: '324',
  },
  {
    name: 'Guinea-Bissau',
    short_name: 'Guinea-Bissau',
    flag: '🇬🇼',
    alpha2: 'GW',
    alpha3: 'GNB',
    numeric: '624',
  },
  {
    name: 'Guyana',
    short_name: 'Guyana',
    flag: '🇬🇾',
    alpha2: 'GY',
    alpha3: 'GUY',
    numeric: '328',
  },
  {
    name: 'Haiti',
    short_name: 'Haiti',
    flag: '🇭🇹',
    alpha2: 'HT',
    alpha3: 'HTI',
    numeric: '332',
  },
  {
    name: 'Heard Island and McDonald Islands',
    short_name: 'Heard Island',
    flag: '🏳',
    alpha2: 'HM',
    alpha3: 'HMD',
    numeric: '334',
  },
  {
    name: 'Holy See (Vatican City State)',
    short_name: 'Vatican City',
    flag: '🇻🇦',
    alpha2: 'VA',
    alpha3: 'VAT',
    numeric: '336',
  },
  {
    name: 'Honduras',
    short_name: 'Honduras',
    flag: '🇭🇳',
    alpha2: 'HN',
    alpha3: 'HND',
    numeric: '340',
  },
  {
    name: 'Hong Kong',
    short_name: 'Hong Kong',
    flag: '🇭🇰',
    alpha2: 'HK',
    alpha3: 'HKG',
    numeric: '344',
  },
  {
    name: 'Hungary',
    short_name: 'Hungary',
    flag: '🇭🇺',
    alpha2: 'HU',
    alpha3: 'HUN',
    numeric: '348',
  },
  {
    name: 'Iceland',
    short_name: 'Iceland',
    flag: '🇮🇸',
    alpha2: 'IS',
    alpha3: 'ISL',
    numeric: '352',
  },
  {
    name: 'India',
    short_name: 'India',
    flag: '🇮🇳',
    alpha2: 'IN',
    alpha3: 'IND',
    numeric: '356',
  },
  {
    name: 'Indonesia',
    short_name: 'Indonesia',
    flag: '🇮🇩',
    alpha2: 'ID',
    alpha3: 'IDN',
    numeric: '360',
  },
  {
    name: 'Iran',
    short_name: 'Iran',
    flag: '🇮🇷',
    alpha2: 'IR',
    alpha3: 'IRN',
    numeric: '364',
  },
  {
    name: 'Iraq',
    short_name: 'Iraq',
    flag: '🇮🇶',
    alpha2: 'IQ',
    alpha3: 'IRQ',
    numeric: '368',
  },
  {
    name: 'Ireland',
    short_name: 'Ireland',
    flag: '🇮🇪',
    alpha2: 'IE',
    alpha3: 'IRL',
    numeric: '372',
  },
  {
    name: 'Isle of Man',
    short_name: 'Isle of Man',
    flag: '🇮🇲',
    alpha2: 'IM',
    alpha3: 'IMN',
    numeric: '833',
  },
  {
    name: 'Israel',
    short_name: 'Israel',
    flag: '🇮🇱',
    alpha2: 'IL',
    alpha3: 'ISR',
    numeric: '376',
  },
  {
    name: 'Italy',
    short_name: 'Italy',
    flag: '🇮🇹',
    alpha2: 'IT',
    alpha3: 'ITA',
    numeric: '380',
  },
  {
    name: 'Jamaica',
    short_name: 'Jamaica',
    flag: '🇯🇲',
    alpha2: 'JM',
    alpha3: 'JAM',
    numeric: '388',
  },
  {
    name: 'Japan',
    short_name: 'Japan',
    flag: '🇯🇵',
    alpha2: 'JP',
    alpha3: 'JPN',
    numeric: '392',
  },
  {
    name: 'Jersey',
    short_name: 'Jersey',
    flag: '🇯🇪',
    alpha2: 'JE',
    alpha3: 'JEY',
    numeric: '832',
  },
  {
    name: 'Jordan',
    short_name: 'Jordan',
    flag: '🇯🇴',
    alpha2: 'JO',
    alpha3: 'JOR',
    numeric: '400',
  },
  {
    name: 'Kazakhstan',
    short_name: 'Kazakhstan',
    flag: '🇰🇿',
    alpha2: 'KZ',
    alpha3: 'KAZ',
    numeric: '398',
  },
  {
    name: 'Kenya',
    short_name: 'Kenya',
    flag: '🇰🇪',
    alpha2: 'KE',
    alpha3: 'KEN',
    numeric: '404',
  },
  {
    name: 'Kiribati',
    short_name: 'Kiribati',
    flag: '🇰🇮',
    alpha2: 'KI',
    alpha3: 'KIR',
    numeric: '296',
  },
  {
    name: "Korea, Democratic People's Republic of",
    short_name: 'North Korea',
    flag: '🇰🇵',
    alpha2: 'KP',
    alpha3: 'PRK',
    numeric: '408',
  },
  {
    name: 'Korea, Republic of',
    short_name: 'South Korea',
    flag: '🇰🇷',
    alpha2: 'KR',
    alpha3: 'KOR',
    numeric: '410',
  },
  {
    name: 'Kosovo',
    short_name: 'Kosovo',
    flag: '🇽🇰',
    alpha2: 'XK',
    alpha3: 'XKX',
    numeric: null, // Kosovo is not officially assigned a numeric code by ISO 3166-1
  },
  {
    name: 'Kuwait',
    short_name: 'Kuwait',
    flag: '🇰🇼',
    alpha2: 'KW',
    alpha3: 'KWT',
    numeric: '414',
  },
  {
    name: 'Kyrgyzstan',
    short_name: 'Kyrgyzstan',
    flag: '🇰🇬',
    alpha2: 'KG',
    alpha3: 'KGZ',
    numeric: '417',
  },
  {
    name: "Lao People's Democratic Republic",
    short_name: 'Laos',
    flag: '🇱🇦',
    alpha2: 'LA',
    alpha3: 'LAO',
    numeric: '418',
  },
  {
    name: 'Latvia',
    short_name: 'Latvia',
    flag: '🇱🇻',
    alpha2: 'LV',
    alpha3: 'LVA',
    numeric: '428',
  },
  {
    name: 'Lebanon',
    short_name: 'Lebanon',
    flag: '🇱🇧',
    alpha2: 'LB',
    alpha3: 'LBN',
    numeric: '422',
  },
  {
    name: 'Lesotho',
    short_name: 'Lesotho',
    flag: '🇱🇸',
    alpha2: 'LS',
    alpha3: 'LSO',
    numeric: '426',
  },
  {
    name: 'Liberia',
    short_name: 'Liberia',
    flag: '🇱🇷',
    alpha2: 'LR',
    alpha3: 'LBR',
    numeric: '430',
  },
  {
    name: 'Libya',
    short_name: 'Libya',
    flag: '🇱🇾',
    alpha2: 'LY',
    alpha3: 'LBY',
    numeric: '434',
  },
  {
    name: 'Liechtenstein',
    short_name: 'Liechtenstein',
    flag: '🇱🇮',
    alpha2: 'LI',
    alpha3: 'LIE',
    numeric: '438',
  },
  {
    name: 'Lithuania',
    short_name: 'Lithuania',
    flag: '🇱🇹',
    alpha2: 'LT',
    alpha3: 'LTU',
    numeric: '440',
  },
  {
    name: 'Luxembourg',
    short_name: 'Luxembourg',
    flag: '🇱🇺',
    alpha2: 'LU',
    alpha3: 'LUX',
    numeric: '442',
  },
  {
    name: 'Macao',
    short_name: 'Macao',
    flag: '🇲🇴',
    alpha2: 'MO',
    alpha3: 'MAC',
    numeric: '446',
  },
  {
    name: 'Macedonia, Republic of',
    short_name: 'North Macedonia',
    flag: '🇲🇰',
    alpha2: 'MK',
    alpha3: 'MKD',
    numeric: '807',
  },
  {
    name: 'Madagascar',
    short_name: 'Madagascar',
    flag: '🇲🇬',
    alpha2: 'MG',
    alpha3: 'MDG',
    numeric: '450',
  },
  {
    name: 'Malawi',
    short_name: 'Malawi',
    flag: '🇲🇼',
    alpha2: 'MW',
    alpha3: 'MWI',
    numeric: '454',
  },
  {
    name: 'Malaysia',
    short_name: 'Malaysia',
    flag: '🇲🇾',
    alpha2: 'MY',
    alpha3: 'MYS',
    numeric: '458',
  },
  {
    name: 'Maldives',
    short_name: 'Maldives',
    flag: '🇲🇻',
    alpha2: 'MV',
    alpha3: 'MDV',
    numeric: '462',
  },
  {
    name: 'Mali',
    short_name: 'Mali',
    flag: '🇲🇱',
    alpha2: 'ML',
    alpha3: 'MLI',
    numeric: '466',
  },
  {
    name: 'Malta',
    short_name: 'Malta',
    flag: '🇲🇹',
    alpha2: 'MT',
    alpha3: 'MLT',
    numeric: '470',
  },
  {
    name: 'Marshall Islands',
    short_name: 'Marshall Islands',
    flag: '🇲🇭',
    alpha2: 'MH',
    alpha3: 'MHL',
    numeric: '584',
  },
  {
    name: 'Martinique',
    short_name: 'Martinique',
    flag: '🇲🇶',
    alpha2: 'MQ',
    alpha3: 'MTQ',
    numeric: '474',
  },
  {
    name: 'Mauritania',
    short_name: 'Mauritania',
    flag: '🇲🇷',
    alpha2: 'MR',
    alpha3: 'MRT',
    numeric: '478',
  },
  {
    name: 'Mauritius',
    short_name: 'Mauritius',
    flag: '🇲🇺',
    alpha2: 'MU',
    alpha3: 'MUS',
    numeric: '480',
  },
  {
    name: 'Mayotte',
    short_name: 'Mayotte',
    flag: '🇾🇹',
    alpha2: 'YT',
    alpha3: 'MYT',
    numeric: '175',
  },
  {
    name: 'Mexico',
    short_name: 'Mexico',
    flag: '🇲🇽',
    alpha2: 'MX',
    alpha3: 'MEX',
    numeric: '484',
  },
  {
    name: 'Micronesia, Federated States of',
    short_name: 'Micronesia',
    flag: '🇫🇲',
    alpha2: 'FM',
    alpha3: 'FSM',
    numeric: '583',
  },
  {
    name: 'Moldova, Republic of',
    short_name: 'Moldova',
    flag: '🇲🇩',
    alpha2: 'MD',
    alpha3: 'MDA',
    numeric: '498',
  },
  {
    name: 'Monaco',
    short_name: 'Monaco',
    flag: '🇲🇨',
    alpha2: 'MC',
    alpha3: 'MCO',
    numeric: '492',
  },
  {
    name: 'Mongolia',
    short_name: 'Mongolia',
    flag: '🇲🇳',
    alpha2: 'MN',
    alpha3: 'MNG',
    numeric: '496',
  },
  {
    name: 'Montenegro',
    short_name: 'Montenegro',
    flag: '🇲🇪',
    alpha2: 'ME',
    alpha3: 'MNE',
    numeric: '499',
  },
  {
    name: 'Montserrat',
    short_name: 'Montserrat',
    flag: '🇲🇸',
    alpha2: 'MS',
    alpha3: 'MSR',
    numeric: '500',
  },
  {
    name: 'Morocco',
    short_name: 'Morocco',
    flag: '🇲🇦',
    alpha2: 'MA',
    alpha3: 'MAR',
    numeric: '504',
  },
  {
    name: 'Mozambique',
    short_name: 'Mozambique',
    flag: '🇲🇿',
    alpha2: 'MZ',
    alpha3: 'MOZ',
    numeric: '508',
  },
  {
    name: 'Myanmar',
    short_name: 'Myanmar',
    flag: '🇲🇲',
    alpha2: 'MM',
    alpha3: 'MMR',
    numeric: '104',
  },
  {
    name: 'Namibia',
    short_name: 'Namibia',
    flag: '🇳🇦',
    alpha2: 'NA',
    alpha3: 'NAM',
    numeric: '516',
  },
  {
    name: 'Nauru',
    short_name: 'Nauru',
    flag: '🇳🇷',
    alpha2: 'NR',
    alpha3: 'NRU',
    numeric: '520',
  },
  {
    name: 'Nepal',
    short_name: 'Nepal',
    flag: '🇳🇵',
    alpha2: 'NP',
    alpha3: 'NPL',
    numeric: '524',
  },
  {
    name: 'Netherlands',
    short_name: 'Netherlands',
    flag: '🇳🇱',
    alpha2: 'NL',
    alpha3: 'NLD',
    numeric: '528',
  },
  {
    name: 'New Caledonia',
    short_name: 'New Caledonia',
    flag: '🇳🇨',
    alpha2: 'NC',
    alpha3: 'NCL',
    numeric: '540',
  },
  {
    name: 'New Zealand',
    short_name: 'New Zealand',
    flag: '🇳🇿',
    alpha2: 'NZ',
    alpha3: 'NZL',
    numeric: '554',
  },
  {
    name: 'Nicaragua',
    short_name: 'Nicaragua',
    flag: '🇳🇮',
    alpha2: 'NI',
    alpha3: 'NIC',
    numeric: '558',
  },
  {
    name: 'Niger',
    short_name: 'Niger',
    flag: '🇳🇪',
    alpha2: 'NE',
    alpha3: 'NER',
    numeric: '562',
  },
  {
    name: 'Nigeria',
    short_name: 'Nigeria',
    flag: '🇳🇬',
    alpha2: 'NG',
    alpha3: 'NGA',
    numeric: '566',
  },
  {
    name: 'Niue',
    short_name: 'Niue',
    flag: '🇳🇺',
    alpha2: 'NU',
    alpha3: 'NIU',
    numeric: '570',
  },
  {
    name: 'Norfolk Island',
    short_name: 'Norfolk Island',
    flag: '🇳🇫',
    alpha2: 'NF',
    alpha3: 'NFK',
    numeric: '574',
  },
  {
    name: 'Northern Mariana Islands',
    short_name: 'Northern Mariana Islands',
    flag: '🏳',
    alpha2: 'MP',
    alpha3: 'MNP',
    numeric: '580',
  },
  {
    name: 'Norway',
    short_name: 'Norway',
    flag: '🇳🇴',
    alpha2: 'NO',
    alpha3: 'NOR',
    numeric: '578',
  },
  {
    name: 'Oman',
    short_name: 'Oman',
    flag: '🇴🇲',
    alpha2: 'OM',
    alpha3: 'OMN',
    numeric: '512',
  },
  {
    name: 'Pakistan',
    short_name: 'Pakistan',
    flag: '🇵🇰',
    alpha2: 'PK',
    alpha3: 'PAK',
    numeric: '586',
  },
  {
    name: 'Palau',
    short_name: 'Palau',
    flag: '🇵🇼',
    alpha2: 'PW',
    alpha3: 'PLW',
    numeric: '585',
  },
  {
    name: 'Palestinian Territory, Occupied',
    short_name: 'Palestine',
    flag: '🇵🇸',
    alpha2: 'PS',
    alpha3: 'PSE',
    numeric: '275',
  },
  {
    name: 'Panama',
    short_name: 'Panama',
    flag: '🇵🇦',
    alpha2: 'PA',
    alpha3: 'PAN',
    numeric: '591',
  },
  {
    name: 'Papua New Guinea',
    short_name: 'Papua New Guinea',
    flag: '🇵🇬',
    alpha2: 'PG',
    alpha3: 'PNG',
    numeric: '598',
  },
  {
    name: 'Paraguay',
    short_name: 'Paraguay',
    flag: '🇵🇾',
    alpha2: 'PY',
    alpha3: 'PRY',
    numeric: '600',
  },
  {
    name: 'Peru',
    short_name: 'Peru',
    flag: '🇵🇪',
    alpha2: 'PE',
    alpha3: 'PER',
    numeric: '604',
  },
  {
    name: 'Philippines',
    short_name: 'Philippines',
    flag: '🇵🇭',
    alpha2: 'PH',
    alpha3: 'PHL',
    numeric: '608',
  },
  {
    name: 'Pitcairn',
    short_name: 'Pitcairn',
    flag: '🇵🇳',
    alpha2: 'PN',
    alpha3: 'PCN',
    numeric: '612',
  },
  {
    name: 'Poland',
    short_name: 'Poland',
    flag: '🇵🇱',
    alpha2: 'PL',
    alpha3: 'POL',
    numeric: '616',
  },
  {
    name: 'Portugal',
    short_name: 'Portugal',
    flag: '🇵🇹',
    alpha2: 'PT',
    alpha3: 'PRT',
    numeric: '620',
  },
  {
    name: 'Puerto Rico',
    short_name: 'Puerto Rico',
    flag: '🇵🇷',
    alpha2: 'PR',
    alpha3: 'PRI',
    numeric: '630',
  },
  {
    name: 'Qatar',
    short_name: 'Qatar',
    flag: '🇶🇦',
    alpha2: 'QA',
    alpha3: 'QAT',
    numeric: '634',
  },
  {
    name: 'Reunion',
    short_name: 'Reunion',
    flag: '🇫🇷',
    alpha2: 'RE',
    alpha3: 'REU',
    numeric: '638',
  },
  {
    name: 'Romania',
    short_name: 'Romania',
    flag: '🇷🇴',
    alpha2: 'RO',
    alpha3: 'ROU',
    numeric: '642',
  },
  {
    name: 'Russian Federation',
    short_name: 'Russia',
    flag: '🇷🇺',
    alpha2: 'RU',
    alpha3: 'RUS',
    numeric: '643',
  },
  {
    name: 'Rwanda',
    short_name: 'Rwanda',
    flag: '🇷🇼',
    alpha2: 'RW',
    alpha3: 'RWA',
    numeric: '646',
  },
  {
    name: 'Saint Barthelemy',
    short_name: 'Saint Barthelemy',
    flag: '🇧🇱',
    alpha2: 'BL',
    alpha3: 'BLM',
    numeric: '652',
  },
  {
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    short_name: 'Saint Helena',
    flag: '🇸🇭',
    alpha2: 'SH',
    alpha3: 'SHN',
    numeric: '654',
  },
  {
    name: 'Saint Kitts and Nevis',
    short_name: 'Saint Kitts and Nevis',
    flag: '🇰🇳',
    alpha2: 'KN',
    alpha3: 'KNA',
    numeric: '659',
  },
  {
    name: 'Saint Lucia',
    short_name: 'Saint Lucia',
    flag: '🇱🇨',
    alpha2: 'LC',
    alpha3: 'LCA',
    numeric: '662',
  },
  {
    name: 'Saint Martin (French part)',
    short_name: 'Saint Martin',
    flag: '🏳',
    alpha2: 'MF',
    alpha3: 'MAF',
    numeric: '663',
  },
  {
    name: 'Saint Pierre and Miquelon',
    short_name: 'Saint Pierre and Miquelon',
    flag: '🇵🇲',
    alpha2: 'PM',
    alpha3: 'SPM',
    numeric: '666',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    short_name: 'Saint Vincent and the Grenadines',
    flag: '🇻🇨',
    alpha2: 'VC',
    alpha3: 'VCT',
    numeric: '670',
  },
  {
    name: 'Samoa',
    short_name: 'Samoa',
    flag: '🇼🇸',
    alpha2: 'WS',
    alpha3: 'WSM',
    numeric: '882',
  },
  {
    name: 'San Marino',
    short_name: 'San Marino',
    flag: '🇸🇲',
    alpha2: 'SM',
    alpha3: 'SMR',
    numeric: '674',
  },
  {
    name: 'Sao Tome and Principe',
    short_name: 'Sao Tome and Principe',
    flag: '🇸🇹',
    alpha2: 'ST',
    alpha3: 'STP',
    numeric: '678',
  },
  {
    name: 'Saudi Arabia',
    short_name: 'KSA',
    flag: '🇸🇦',
    alpha2: 'SA',
    alpha3: 'SAU',
    numeric: '682',
  },
  {
    name: 'Senegal',
    short_name: 'Senegal',
    flag: '🇸🇳',
    alpha2: 'SN',
    alpha3: 'SEN',
    numeric: '686',
  },
  {
    name: 'Serbia',
    short_name: 'Serbia',
    flag: '🇷🇸',
    alpha2: 'RS',
    alpha3: 'SRB',
    numeric: '688',
  },
  {
    name: 'Seychelles',
    short_name: 'Seychelles',
    flag: '🇸🇨',
    alpha2: 'SC',
    alpha3: 'SYC',
    numeric: '690',
  },
  {
    name: 'Sierra Leone',
    short_name: 'Sierra Leone',
    flag: '🇸🇱',
    alpha2: 'SL',
    alpha3: 'SLE',
    numeric: '694',
  },
  {
    name: 'Singapore',
    short_name: 'Singapore',
    flag: '🇸🇬',
    alpha2: 'SG',
    alpha3: 'SGP',
    numeric: '702',
  },
  {
    name: 'Slovakia',
    short_name: 'Slovakia',
    flag: '🇸🇰',
    alpha2: 'SK',
    alpha3: 'SVK',
    numeric: '703',
  },
  {
    name: 'Slovenia',
    short_name: 'Slovenia',
    flag: '🇸🇮',
    alpha2: 'SI',
    alpha3: 'SVN',
    numeric: '705',
  },
  {
    name: 'Solomon Islands',
    short_name: 'Solomon Islands',
    flag: '🇸🇧',
    alpha2: 'SB',
    alpha3: 'SLB',
    numeric: '090',
  },
  {
    name: 'Somalia',
    short_name: 'Somalia',
    flag: '🇸🇴',
    alpha2: 'SO',
    alpha3: 'SOM',
    numeric: '706',
  },
  {
    name: 'South Africa',
    short_name: 'South Africa',
    flag: '🇿🇦',
    alpha2: 'ZA',
    alpha3: 'ZAF',
    numeric: '710',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    short_name: 'South Georgia',
    flag: '🇬🇸',
    alpha2: 'GS',
    alpha3: 'SGS',
    numeric: '239',
  },
  {
    name: 'South Sudan',
    short_name: 'South Sudan',
    flag: '🇸🇸',
    alpha2: 'SS',
    alpha3: 'SSD',
    numeric: '728',
  },
  {
    name: 'Spain',
    short_name: 'Spain',
    flag: '🇪🇸',
    alpha2: 'ES',
    alpha3: 'ESP',
    numeric: '724',
  },
  {
    name: 'Sri Lanka',
    short_name: 'Sri Lanka',
    flag: '🇱🇰',
    alpha2: 'LK',
    alpha3: 'LKA',
    numeric: '144',
  },
  {
    name: 'Sudan',
    short_name: 'Sudan',
    flag: '🇸🇩',
    alpha2: 'SD',
    alpha3: 'SDN',
    numeric: '729',
  },
  {
    name: 'Suriname',
    short_name: 'Suriname',
    flag: '🇸🇷',
    alpha2: 'SR',
    alpha3: 'SUR',
    numeric: '740',
  },
  {
    name: 'Svalbard and Jan Mayen',
    short_name: 'Svalbard and Jan Mayen',
    flag: '🇩🇰',
    alpha2: 'SJ',
    alpha3: 'SJM',
    numeric: '744',
  },
  {
    name: 'Swaziland',
    short_name: 'Swaziland',
    flag: '🇸🇿',
    alpha2: 'SZ',
    alpha3: 'SWZ',
    numeric: '748',
  },
  {
    name: 'Sweden',
    short_name: 'Sweden',
    flag: '🇸🇪',
    alpha2: 'SE',
    alpha3: 'SWE',
    numeric: '752',
  },
  {
    name: 'Switzerland',
    short_name: 'Switzerland',
    flag: '🇨🇭',
    alpha2: 'CH',
    alpha3: 'CHE',
    numeric: '756',
  },
  {
    name: 'Syrian Arab Republic',
    short_name: 'Syria',
    flag: '🇸🇾',
    alpha2: 'SY',
    alpha3: 'SYR',
    numeric: '760',
  },
  {
    name: 'Taiwan, Province of China',
    short_name: 'Taiwan',
    flag: '🇹🇼',
    alpha2: 'TW',
    alpha3: 'TWN',
    numeric: '158',
  },
  {
    name: 'Tajikistan',
    short_name: 'Tajikistan',
    flag: '🇹🇯',
    alpha2: 'TJ',
    alpha3: 'TJK',
    numeric: '762',
  },
  {
    name: 'Tanzania, United Republic of',
    short_name: 'Tanzania',
    flag: '🇹🇿',
    alpha2: 'TZ',
    alpha3: 'TZA',
    numeric: '834',
  },
  {
    name: 'Thailand',
    short_name: 'Thailand',
    flag: '🇹🇭',
    alpha2: 'TH',
    alpha3: 'THA',
    numeric: '764',
  },
  {
    name: 'Timor-Leste',
    short_name: 'Timor-Leste',
    flag: '🇹🇱',
    alpha2: 'TL',
    alpha3: 'TLS',
    numeric: '626',
  },
  {
    name: 'Togo',
    short_name: 'Togo',
    flag: '🇹🇬',
    alpha2: 'TG',
    alpha3: 'TGO',
    numeric: '768',
  },
  {
    name: 'Tokelau',
    short_name: 'Tokelau',
    flag: '🇹🇰',
    alpha2: 'TK',
    alpha3: 'TKL',
    numeric: '772',
  },
  {
    name: 'Tonga',
    short_name: 'Tonga',
    flag: '🇹🇴',
    alpha2: 'TO',
    alpha3: 'TON',
    numeric: '776',
  },
  {
    name: 'Trinidad and Tobago',
    short_name: 'Trinidad and Tobago',
    flag: '🇹🇹',
    alpha2: 'TT',
    alpha3: 'TTO',
    numeric: '780',
  },
  {
    name: 'Tunisia',
    short_name: 'Tunisia',
    flag: '🇹🇳',
    alpha2: 'TN',
    alpha3: 'TUN',
    numeric: '788',
  },
  {
    name: 'Turkey',
    short_name: 'Turkey',
    flag: '🇹🇷',
    alpha2: 'TR',
    alpha3: 'TUR',
    numeric: '792',
  },
  {
    name: 'Turkmenistan',
    short_name: 'Turkmenistan',
    flag: '🇹🇲',
    alpha2: 'TM',
    alpha3: 'TKM',
    numeric: '795',
  },
  {
    name: 'Turks and Caicos Islands',
    short_name: 'Turks and Caicos Islands',
    flag: '🇹🇨',
    alpha2: 'TC',
    alpha3: 'TCA',
    numeric: '796',
  },
  {
    name: 'Tuvalu',
    short_name: 'Tuvalu',
    flag: '🇹🇻',
    alpha2: 'TV',
    alpha3: 'TUV',
    numeric: '798',
  },
  {
    name: 'Uganda',
    short_name: 'Uganda',
    flag: '🇺🇬',
    alpha2: 'UG',
    alpha3: 'UGA',
    numeric: '800',
  },
  {
    name: 'Ukraine',
    short_name: 'Ukraine',
    flag: '🇺🇦',
    alpha2: 'UA',
    alpha3: 'UKR',
    numeric: '804',
  },
  {
    name: 'United Arab Emirates',
    short_name: 'UAE',
    flag: '🇦🇪',
    alpha2: 'AE',
    alpha3: 'ARE',
    numeric: '784',
  },
  {
    name: 'United Kingdom',
    short_name: 'UK',
    flag: '🇬🇧',
    alpha2: 'GB',
    alpha3: 'GBR',
    numeric: '826',
  },
  {
    name: 'United States',
    short_name: 'USA',
    flag: '🇺🇸',
    alpha2: 'US',
    alpha3: 'USA',
    numeric: '840',
  },
  {
    name: 'Uruguay',
    short_name: 'Uruguay',
    flag: '🇺🇾',
    alpha2: 'UY',
    alpha3: 'URY',
    numeric: '858',
  },
  {
    name: 'Uzbekistan',
    short_name: 'Uzbekistan',
    flag: '🇺🇿',
    alpha2: 'UZ',
    alpha3: 'UZB',
    numeric: '860',
  },
  {
    name: 'Vanuatu',
    short_name: 'Vanuatu',
    flag: '🇻🇺',
    alpha2: 'VU',
    alpha3: 'VUT',
    numeric: '548',
  },
  {
    name: 'Venezuela, Bolivarian Republic of',
    short_name: 'Venezuela',
    flag: '🇻🇪',
    alpha2: 'VE',
    alpha3: 'VEN',
    numeric: '862',
  },
  {
    name: 'Vietnam',
    short_name: 'Vietnam',
    flag: '🇻🇳',
    alpha2: 'VN',
    alpha3: 'VNM',
    numeric: '704',
  },
  {
    name: 'Virgin Islands, British',
    short_name: 'British Virgin Islands',
    flag: '🇻🇬',
    alpha2: 'VG',
    alpha3: 'VGB',
    numeric: '092',
  },
  {
    name: 'Virgin Islands, U.S.',
    short_name: 'U.S. Virgin Islands',
    flag: '🇻🇮',
    alpha2: 'VI',
    alpha3: 'VIR',
    numeric: '850',
  },
  {
    name: 'Wallis and Futuna',
    short_name: 'Wallis and Futuna',
    flag: '🇼🇫',
    alpha2: 'WF',
    alpha3: 'WLF',
    numeric: '876',
  },
  {
    name: 'Yemen',
    short_name: 'Yemen',
    flag: '🇾🇪',
    alpha2: 'YE',
    alpha3: 'YEM',
    numeric: '887',
  },
  {
    name: 'Zambia',
    short_name: 'Zambia',
    flag: '🇿🇲',
    alpha2: 'ZM',
    alpha3: 'ZMB',
    numeric: '894',
  },
  {
    name: 'Zimbabwe',
    short_name: 'Zimbabwe',
    flag: '🇿🇼',
    alpha2: 'ZW',
    alpha3: 'ZWE',
    numeric: '716',
  },
];

const countryByAlpha2 = Object.fromEntries(countries.map((c) => [c.alpha2, c]));
const countryByAlpha3 = Object.fromEntries(countries.map((c) => [c.alpha3, c]));
const countryByNumeric = Object.fromEntries(
  countries.map((c) => [c.numeric, c])
);